import { render, staticRenderFns } from "./DialogFixarColunas.vue?vue&type=template&id=48f2d92a&scoped=true&"
import script from "./DialogFixarColunas.vue?vue&type=script&lang=js&"
export * from "./DialogFixarColunas.vue?vue&type=script&lang=js&"
import style0 from "./DialogFixarColunas.vue?vue&type=style&index=0&id=48f2d92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2d92a",
  null
  
)

export default component.exports